module.exports = __webpack_public_path__ + "assets/img/zh_icon.4ec19bf6.svg";